import { Injectable } from '@angular/core';
import { RolleRettighed } from './rolle-rettighed.model';
import { RestApi } from '@core/api/rest.api';

@Injectable({
  providedIn: 'root'
})
export class RolleRettighedApi extends RestApi<RolleRettighed> {

  override endpoint='/v2/rollerettigheder';

}
